const validate = (attrs = {}) => {
  const errors = {};
  if (!attrs.section || !attrs.section.value) {
    errors.section = 'Debe seleccionar una materia';
  }

  if (
    !attrs.editedStudentEnrollments
    || !attrs.editedStudentEnrollments.length
    || !attrs.editedStudentEnrollments.some(e => e.selected)) {
    errors.checkAll = 'Debe seleccionar un alumno';
  }

  if (Object.keys(errors).length) {
    console.error(errors);
  }

  return errors;
};

export default validate;
